import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web'
import StandardModal from '../app_components/StandardModal'
import StandardButton from '../app_components/StandardButton'

class LexicoinAlert extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      show: true,
      id: '',
    }

    this.confettiRef = React.createRef()
    this.confettiAnimation = null
    this.toggleAlert = this.toggleAlert.bind(this)
    this.loadLottie = this.loadLottie.bind(this)
    this.destroyLottie = this.destroyLottie.bind(this)
  }

  loadLottie() {
    if (!this.confettiRef.current || !this.props.confettiLottie) {
      return
    }

    this.destroyLottie()
    this.confettiAnimation = lottie.loadAnimation({
      container: this.confettiRef.current,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: this.props.confettiLottie,
    })
  }

  destroyLottie() {
    if (this.confettiAnimation) {
      this.confettiAnimation.destroy()
      this.confettiAnimation = null
    }
  }

  componentDidMount() {
    this.setState({
      show: true,
      id: this.props.points.id,
    })
    this.loadLottie()
  }

  componentDidUpdate(prevProps) {
    if (this.state.id !== this.props.points.id) {
      this.setState({
        id: this.props.points.id,
        show: true,
      }, () => this.loadLottie())
    } else if (prevProps.confettiLottie !== this.props.confettiLottie) {
      this.loadLottie()
    }
  }

  componentWillUnmount() {
    this.destroyLottie()
  }

  toggleAlert() {
    this.setState({ show: false })

    if (this.props.preview) {
      if (this.props.onClose) {
        this.props.onClose()
      }
      return
    }

    this.props.deleteNotification(this.state.id)
    if (this.props.onDismissed) {
      this.props.onDismissed()
    }
  }

  render() {
    if (this.state.show === false) {
      return null
    }

    const { value, notes } = this.props.points
    const coinLabel = value === 1 ? 'Lexicoin' : 'Lexicoins'

    return (
      <StandardModal
        onClose={this.toggleAlert}
        title={`You earned ${value} ${coinLabel}`}
        modalClass="celebrationModal celebrationModal--lexicoin"
        overlayClass="celebrationModalOverlay"
      >
        <div className="celebrationModal__confetti" ref={this.confettiRef} aria-hidden="true" />
        <div className="celebrationModal__content">
          <p className="celebrationModal__eyebrow">Nice work!</p>
          <img
            className="celebrationModal__image celebrationModal__image--lexicoin"
            src={this.props.lexicoin}
            alt=""
          />
          <h2 className="celebrationModal__title">
            You earned {value} {coinLabel}!
          </h2>
          {notes &&
            <p className="celebrationModal__body">{notes}</p>
          }
          <StandardButton
            text="Sweet!"
            primary
            fullWidth
            onClick={this.toggleAlert}
          />
        </div>
      </StandardModal>
    )
  }
}

LexicoinAlert.propTypes = {
  points: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.number.isRequired,
    notes: PropTypes.string,
  }).isRequired,
  confettiLottie: PropTypes.string,
  lexicoin: PropTypes.string.isRequired,
  deleteNotification: PropTypes.func,
  preview: PropTypes.bool,
  onClose: PropTypes.func,
  onDismissed: PropTypes.func,
}

LexicoinAlert.defaultProps = {
  preview: false,
  deleteNotification: () => {},
}

export default LexicoinAlert
